// extracted by mini-css-extract-plugin
export default {"container":"EY-z","list":"FY-z"};